import { forwardRef, useMemo } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { Container, StyledFormLabel, StyledFormHelperText } from "./CommonStyles";
import { SelectMenu, SelectOption } from "@kaltura/ds-react-components";

export interface SelectMenuFieldProps {
    className?: string;
    id: string;
    label: string;
    description?: string;
    value?: string;
    required?: boolean;
    options: SelectOption[];
    placeholder?: string;
}

/**
 * select menu controlled field
 */
export const SelectMenuField = forwardRef<any, SelectMenuFieldProps>(
    ({ className, id, label, description, value: defaultValue, required, options, placeholder }, ref) => {
        const { control } = useFormContext();

        return (
            <Container className={className}>
                <StyledFormLabel
                    htmlFor={id}
                    text={label}
                    required={required}
                    fontWeightBold={true}
                    id={`${id}-select-label`}
                />

                <StyledFormHelperText id={`${id}-description`}>{description}</StyledFormHelperText>

                <Controller
                    control={control}
                    name={id}
                    defaultValue={defaultValue ?? ""}
                    rules={{ required: required }}
                    render={({ field: { onChange, onBlur, value } }) => (
                        <SelectMenu
                            id={id}
                            inputRef={ref}
                            defaultValue={value}
                            value={value}
                            placeholder={placeholder}
                            options={options}
                            onChange={onChange}
                            onBlur={onBlur}
                            inputProps={{ "aria-labelledby": `${id}-select-label`, "aria-label": placeholder }}
                        />
                    )}
                />
            </Container>
        );
    }
);
